<template>
 <div name="pupilselect" >
         
              <ul class="ml-6" >
                  <li class="inline-block mr-10"> 
                       <dropdown v-if="classes.length > 0" :options="classDropdown" :css="'text-white'" :selected="selectedClass" v-on:updateOption="classSelect" 
                    class="w-56 bg-blue-600 mb-10 ml-4 pl-3" ></dropdown>
                  </li>

                         <li class="inline-block">  
                          <input type="search" class="h-full w-64 bg-white rounded shadow-sm p-2 mr-3"
                                         name="search"  v-model="search" placeholder="Enter search term..." >
                              </li>
                            </ul>


                     <table class="w-95p mx-auto mb-2 h-12 pt-2 align-text-bottom bg-white rounded text-left text-gray-400">
                              <thead>
                                <tr>
                                  <th width="15%" class="pl-2">
                                   Year Group
                                  </th>
                                  <th width="30%" >Name</th>
                                  <th width="19%"> Class</th>

                                  <th width="10%"></th>
                                </tr>
                              </thead>
                            </table>

                
                              <div class="table-wrapper">

                                <div v-if="errored" class="empty">
                    <p>We are not able to retrieve this information at the moment, please try back later</p>
                  </div>



                <div id="content-area" v-else>
                  <div style="width:100%; text-align:center;" v-if="loading" >
                    <i class="spinner fa fa-spinner fa-spin"></i>
                  </div>

                    <div v-else>
                            <table v-if="pupils.length > 0" class="table-wrapper w-95p bg-white mx-auto rounded shadow-sm" >
                              <tbody>
                                  <tr v-for="pupil in filteredList">
                 
                                     <td width="15%">
                                        <div v-for="year in years" :key="year.id" v-if="year.value == pupil.yeargroup">
                                       {{ year.name }}
                                    </div>
                                     </td>
                                    <td width="30%">{{ pupil.name }}</td>
                                    <td width="20%">{{ pupil.class }}</td>

                                    <td width="10%" class="text-center text-xs cursor-not-allowed text-blue-400">
                                      <span v-if="inSelected(pupil)"> <i class="fas fa-check-double text-green-300"></i></span>
                                      <a v-else class="cursor-pointer "
                                      @click="selectPupil(pupil)" >Select Pupil</a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>

                               <p class="m-5 mx-12" v-else>We could not find any data for your given selection.</p>
                          </div>

                        </div>

              </div>

        </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SchoolService } from "@/services/school.service";
import { PupilService } from "@/services/pupil.service";
import { yearGroupMixin} from "@/mixins/yearGroupMixin.js";

const dropdown = () => import('@/components/Dropdown.vue')


export default {
  name: "pupilselect",
    mixins: [yearGroupMixin],
    props: {
      pupilsSelected: Array,
    },
  computed: {
    ...mapGetters({ currentUser: "currentUser" }),
    classDropdown () {
      var results = this.classes
      if (this.selectedClass === undefined) {
          this.selectedClass = results[0]
      }
      return results
    },
    orderedPupils() {
      var vm = this;
      let years = vm.filteredYears;
      var classChosen = vm.selectedClass;

       if (years.length == 0 && classChosen.id == 0  ) {
        return _.orderBy(this.pupils, ["yeargroup", "class", "name"]);
      } else {
        var filtered = vm.pupils.filter(function(pupil) {
          let filtered = true;

     
          if (years.length > 0) {
            filtered = years.includes(pupil.yeargroup);
           }

          if (filtered) {
            if (classChosen.id > 0) {
              filtered = pupil.class === classChosen.name;
            }
          }
          return filtered;
        });

        return _.orderBy(filtered, ["yeargroup", "class", "name"]);
      }
    },
    filteredList() {
     return this.orderedPupils.filter(item => {
       var vm = this;
       return item.name.toLowerCase().includes(vm.search.toLowerCase())
     })
   },
  },
  data() {
    return {
      loading: true,
      errored: false,
        pupils: [],
        selectedClass: {},
        types: [],
        classes: [],
       filteredYears: [],
       search: '',
    };
  },
  created() {
    this.fetchPupils()

    PupilService.getClasses()
    .then(response => this.buildClassList(response.data.data))
    .catch(err => {
      console.log("classes " + err);
      this.errored = true;
    })
  },
  methods: {
    buildClassList(data) {
      this.classes = data.map(function(item, index) {
        return {"id": index + 1, "name": item}
      });
      this.classes = [{ id: 0, name: "Select a class" }].concat(this.classes)
      this.selectedClass = this.classes[0];
    },
    fetchPupils() {
      PupilService.getAll()
        .then(response => this.buildPupilList(response.data))
        .catch(err => {
          console.log("Pupils " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    buildPupilList(data) {
      this.pupils = data
    },
    setClass() {
       let t = this.classes
        .filter(tt => { return tt.name == this.pupil.class })
        .shift()
      this.selectedClass = t
    },
    classSelect (value) {
      this.selectedClass = value
    },
    inSelected(value) {
      let found = this.pupilsSelected.find(l => l.register.identifier === value.identifier)
      return found
    },
    selectPupil(pupil) {
      this.$emit('pupil-selected', pupil)
    }
  },
  components: {
    dropdown
  }
};
</script>

<style scoped>

</style>
